import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import GlassButton from '../ui/GlassButton';

export default function Hero() {
    const navigate = useNavigate();

    return (
        <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
            {/* Background Elements */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/[0.02] rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute top-0 left-0 w-full h-full bg-[url('/grid-pattern.svg')] opacity-[0.03] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
                {/* Badge */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.05] border border-white/[0.1] backdrop-blur-md mb-8"
                >
                    <span className="w-2 h-2 rounded-full bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.5)] animate-pulse" />
                    <span className="text-sm text-zinc-300 tracking-wide uppercase font-medium">AI Automation for Enterprise</span>
                </motion.div>

                {/* Headline */}
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-6xl md:text-8xl font-bold tracking-tight mb-8"
                >
                    Master Your Next <br />
                    <span className="text-gradient">Interview with AI</span>
                </motion.h1>

                {/* Subcopy */}
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-xl text-zinc-400 max-w-2xl mx-auto mb-12 leading-relaxed"
                >
                    Practice real-time interviews with our advanced AI. Get instant feedback on your tone, body language, and answers to land your dream job.
                </motion.p>

                {/* CTAs */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="flex flex-col sm:flex-row items-center justify-center gap-4"
                >
                    <GlassButton
                        variant="primary"
                        size="lg"
                        onClick={() => navigate('/login')}
                        icon={<i className="ri-rocket-line"></i>}
                    >
                        Start Practicing Free
                    </GlassButton>

                    <GlassButton
                        variant="outline"
                        size="lg"
                        onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                        icon={<i className="ri-play-circle-line"></i>}
                    >
                        Watch Demo
                    </GlassButton>
                </motion.div>

                {/* Trusted By - Minimal */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.8 }}
                    className="mt-32 pt-10 border-t border-white/[0.05]"
                >
                    <p className="text-sm text-zinc-500 uppercase tracking-widest mb-8">Trusted by candidates from</p>
                    <div className="flex flex-wrap justify-center gap-12 opacity-40 grayscale hover:grayscale-0 transition-all duration-500">
                        {/* Simple Text Placeholders for Logos to keep it clean */}
                        <span className="text-xl font-bold text-white">Google</span>
                        <span className="text-xl font-bold text-white">Amazon</span>
                        <span className="text-xl font-bold text-white">Meta</span>
                        <span className="text-xl font-bold text-white">Netflix</span>
                        <span className="text-xl font-bold text-white">Spotify</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
